import React from 'react';

const DisplayInfo = (props) => (
    <div className={`display-info ${props.color ? props.color : ''} font-size${props.fontSize ? props.fontSize : "14"}`}>
        <div className={`display-info-title ${props.title ? props.title : 'hidden'}`}>{props.title}</div>
        {props.children}
    </div>
);

export default DisplayInfo;